import React, {useEffect, useState} from "react";
import {Button, ConfigProvider, Form, message, Modal, Select} from "antd";
import locale from "antd/es/locale/es_ES";
import {GetAllAules} from "../../dao/GetAllAules";
import HomeColors from "../../styles/HomeColors";
import {CopyAulaModal} from "../../dao/PostAulaIdCopy";

interface Props {
    id_aula: any;
    visible: boolean;
    onClose: (updated: boolean) => void;
}

const CopyModal: React.FC<Props> = ({id_aula, visible, onClose}) => {
    const [aules, setAules] = useState<any[]>([]);
    const [selectedAules, setSelectedAules] = useState<number[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (visible) loadAules();
    }, [visible]);

    async function loadAules() {
        try {
            const data = await GetAllAules("");
            setAules(data || []);
        } catch (err) {
            console.error(err);
            message.error("Error carregant les aules");
        }
    }

    const handleCancel = () => {
        setSelectedAules([]);
        onClose(false);
    };

    async function handleGuardar() {
        if (!selectedAules.length) {
            message.warning("Selecciona almenys una aula");
            return;
        }

        try {
            setLoading(true);
            console.log(selectedAules);
            await CopyAulaModal(id_aula+"", selectedAules);
            message.success("Pràctica duplicada correctament!");
            onClose(true);
        } catch (err) {
            console.error(err);
            message.error("Error en duplicar la pràctica");
        } finally {
            setLoading(false);
        }
    }

    return (
        <ConfigProvider locale={locale}>
            <Modal
                title="Duplicar pràctica"
                open={visible}
                onCancel={handleCancel}
                footer={null}
                width={500}
            >
                <Form layout="vertical">
                    <Form.Item
                        label="Selecciona les aules destinataries"
                        tooltip="Tria una o més aules on vols duplicar aquesta pràctica"
                    >
                        <Select
                            mode="multiple"
                            placeholder="Selecciona les aules"
                            value={selectedAules}
                            onChange={(values) => setSelectedAules(values)}
                            style={{width: "100%"}}
                        >
                            {aules.map((aula: any) => (
                                <Select.Option key={aula.id} value={aula.id}>
                                    {aula.nom}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <div style={{textAlign: "right"}}>
                        <Button onClick={handleCancel} style={{marginRight: 8}}>
                            Cancel·lar
                        </Button>
                        <Button
                            type="primary"
                            style={{backgroundColor: HomeColors.colors.color4}}
                            loading={loading}
                            onClick={handleGuardar}
                        >
                            Guardar
                        </Button>
                    </div>
                </Form>
            </Modal>
        </ConfigProvider>
    );
};

export default CopyModal;
